import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Button from '../../ui/Button';
import ButtonsGroup from '../../ui/ButtonsGroup';
import ShareIcon from '../../assets/icons/share.svg';
import DownloadIcon from '../../assets/icons/download.svg';
import { useTranslation } from 'react-i18next';
import { sendCompleteGame } from '../../api/game-mode/game';
import { GAME_END_TIME, GAME_START_TIME, GAME_TIME_LEFT } from '../../app.config.vars/stored';
import { GAME_DB } from '../../db/game';
import { setIsModalOpen, setModalContent, selectIsSyncing, setModalContentProps, } from '../../store/slices/global';
import { useAppDispatch } from '../../store';
import { useSelector } from 'react-redux';
import { selectGameStatus } from '../../store/slices/rallyGame';
import { MODAL_CONTENT } from '../../app.config.vars/modalContent';
import { takeScreenshot, triggerDownload } from '../../helpers';
import { useParams } from 'react-router-dom';
const GameResultControls = ({ points, minutes, rallyTitle }) => {
    const { id } = useParams();
    const { t } = useTranslation();
    const dispatch = useAppDispatch();
    const gameStatus = useSelector(selectGameStatus);
    const isSyncing = useSelector(selectIsSyncing);
    const onShareGameResult = () => {
        dispatch(setIsModalOpen(true));
        dispatch(setModalContent(MODAL_CONTENT.shareSocials.key));
        dispatch(setModalContentProps({
            shareUrl: `${location.origin}/rallies/${id}`,
            points,
            minutes,
            rallyTitle,
        }));
    };
    const onSaveGameResult = async () => {
        if (isSyncing) {
            dispatch(setIsModalOpen(true));
            dispatch(setModalContent(MODAL_CONTENT.syncInProgress.key));
            return;
        }
        const gameEndTime = localStorage.getItem(GAME_END_TIME);
        if (gameEndTime) {
            const gameCompleted = await sendCompleteGame({
                isTimedOut: gameStatus === 'timeout',
                endTime: gameEndTime,
            });
            if (!gameCompleted.error) {
                localStorage.removeItem(GAME_START_TIME);
                localStorage.removeItem(GAME_END_TIME);
                localStorage.removeItem(GAME_TIME_LEFT);
                await GAME_DB.RESET.game();
                dispatch(setIsModalOpen(true));
                dispatch(setModalContent(MODAL_CONTENT.gameResultSuccessfullySaved.key));
            }
            else {
                dispatch(setIsModalOpen(true));
                dispatch(setModalContent(MODAL_CONTENT.noInternetToSaveGameResult.key));
            }
        }
        else {
            dispatch(setIsModalOpen(true));
            dispatch(setModalContent(MODAL_CONTENT.finishUncompletedGame.key));
        }
    };
    const getScreenshotBounds = () => {
        const elements = document.querySelectorAll('.screenshot-content');
        let minX = Infinity, minY = Infinity;
        let maxX = -Infinity, maxY = -Infinity;
        elements.forEach((el) => {
            const rect = el.getBoundingClientRect();
            minX = Math.min(minX, rect.left);
            minY = Math.min(minY, rect.top);
            maxX = Math.max(maxX, rect.right);
            maxY = Math.max(maxY, rect.bottom);
        });
        // return a DOMRect-like object
        return new DOMRect(minX, minY, maxX - minX, maxY - minY);
    };
    const onDownloadGameResult = async () => {
        const root = document.getElementById('root');
        if (root) {
            const bounds = getScreenshotBounds();
            const screenshot = await takeScreenshot({
                element: root,
                options: {
                    width: bounds.width,
                    height: bounds.height - 28,
                    style: {
                        transform: `translate(${-bounds.x}px, ${-bounds.y + 16}px)`,
                        textRendering: 'geometricPrecision', // improves Safari text rendering
                    },
                    backgroundColor: '#ffffff',
                },
            });
            if (screenshot) {
                triggerDownload({ file: screenshot, filename: 'comp@ss-game-result.png' });
            }
        }
    };
    return (_jsxs(ButtonsGroup, { justify: gameStatus === 'can-be-completed' ? 'between' : 'end', children: [gameStatus === 'can-be-completed' && (_jsxs(ButtonsGroup, { children: [_jsx(Button, { onClick: onShareGameResult, label: t('button.share'), variant: 'outlined', icon: _jsx(ShareIcon, {}), manageIcon: 'fill' }), _jsx(Button, { onClick: onDownloadGameResult, label: t('button.download'), variant: 'outlined', icon: _jsx(DownloadIcon, {}), manageIcon: 'fill' })] })), _jsx(Button, { label: gameStatus === 'can-be-completed' ? t('button.save_and_exit') : t('button.abbort_and_end'), onClick: onSaveGameResult })] }));
};
export default GameResultControls;
